module.exports = __webpack_public_path__ + "static/media/Mudbray_gaussian2.bf1852bb.png";